export default __webpack_public_path__ + "static/media/SensorCalfRight.bde2b665.svg";